<div class="section">
  <div class="container-fluid">
    <div class="container">
      <div class="row align-items-center justify-content-center py-4">
        <div class="col-xs-12 col-sm-12 col-lg-6"></div>
      </div>
    </div>
  </div>
</div>
